export default {
  categories: [],
  detail: '',
  fechaVencimiento: ''
}
